/* eslint-disable sort-keys */

const breakpoints = {
  mini: '576px', // Extra small devices (portrait phones)
  mobile: '768px', // Small devices (landscape phones, small tablets)
  tablet: '1024px', // Medium devices (tablets, small laptops)
  desktop: '1400px', // Large devices (desktops, large laptops)
  largeDesktop: '1700px', // Extra large devices (large desktops)
  xlDesktop: '2560px', // Extra extra large devices (4K monitors)
};

export default breakpoints;
